import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { readableTypeName } from '@iotv/core-services';
import { Stack, Typography } from '@mui/material';
import { ListerlizerAdapter } from '../../../../components/factories/Listerlizer/legacy/ListerlizerAdapter';
const debug = process.env.REACT_APP_DEBUG && false;
export default function ListCard(props) {
    const { columnVisibilityReferences, applicationData, userFunctions, transactionFunctions, viewObject, mostProximateCustomer, adjacentFilter, viewDefinition, maxItems, listConfigParams, } = props;
    debug && console.log('ListCard', props);
    const nameLabel = listConfigParams.label
        ? `${viewObject.matchedPrimary?.name} ${listConfigParams?.label}`
        : `${viewObject.matchedPrimary?.name} is linked to ${readableTypeName(adjacentFilter.objectType)}`;
    const sortKeyIn = Object.keys(viewDefinition)[0];
    const contextObject = viewObject.matchedPrimary;
    let searchRootObject = mostProximateCustomer;
    let linkableItemsBranchingQueryDefinition = undefined;
    /**
     * 2024 04 currently List item cannot automatically configure searchRootObject - To be done as part of exposing getLinkableItems query strategies
     */
    return (_jsxs(Stack, { width: "100%", children: [_jsx(Typography, { variant: "h6", children: nameLabel }), _jsx(ListerlizerAdapter, { viewObject,
                contextObject,
                mostProximateCustomer,
                searchRootObject,
                adjacentFilter,
                maxItems,
                columnVisibilityReferences,
                transactionFunctions,
                userFunctions,
                viewDefinition,
                sortKeyIn,
                initialSort: [{ field: sortKeyIn ?? 'name', sort: 'asc' }] })] }));
}
